import { Svg, Circle } from 'react-native-svg';
const DotKey = () => {
  return (
    <Svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <Circle cx="8" cy="8" r="8" fill="#1E1E1E" />
    </Svg>
  );
};

export default DotKey;
